import { ShieldCheck, Landmark } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { REGISTRATIONS, CLIENTS } from "../../data/site";
import { BrochureButton } from "./BrochureButton";

export const Credentials = () => (
  <section id="registrations" data-testid="credentials-section" className="section bg-[var(--paper)]">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal>
        <Eyebrow>Compliance</Eyebrow>
        <h2 className="section-title mt-4">Registrations</h2>
        <p className="mt-4 max-w-2xl text-[var(--muted-ink)]">All registrations are held in the firm's name, Vata Infrastructures, with Darshan Bhaskar T as proprietor.</p>
        <BrochureButton dark className="mt-6" testid="credentials-brochure-button" />
      </Reveal>
      <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {REGISTRATIONS.map((r, i) => (
          <Reveal key={r.name} delay={(i % 3) * 0.06} className="border border-black/10 bg-white p-6 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-[var(--rust)]" data-testid={`registration-card-${i}`}>
            <ShieldCheck className="h-5 w-5 text-[var(--rust)]" />
            <p className="mt-4 font-mono text-xs uppercase tracking-wider text-[var(--muted-ink)]">{r.name}</p>
            <p className="mt-1 break-all font-display text-2xl font-bold text-[var(--ink)]">{r.id}</p>
            <p className="mt-2 text-sm text-[var(--muted-ink)]">{r.note}</p>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-24">
        <Eyebrow>Who we work for</Eyebrow>
        <h2 className="section-title mt-4">Clients</h2>
      </Reveal>
      <div className="mt-10 grid gap-8 md:grid-cols-3">
        {CLIENTS.map((c, i) => (
          <Reveal key={c.name} delay={i * 0.08} className="border-t-4 border-[var(--forest)] pt-6" data-testid={`client-${i}`}>
            <Landmark className="h-6 w-6 text-[var(--forest)]" />
            <h3 className="mt-4 font-display text-2xl font-bold uppercase">{c.name}</h3>
            <ul className="mt-3 space-y-1 text-sm text-[var(--muted-ink)]">
              {c.units.map((u) => <li key={u}>{u}</li>)}
            </ul>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
